export default function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/ascending.js
// module id = 153
// module chunks = 0